import React, { useContext, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { id } from '../../../../filters/options/store';
import { isOperator } from '../../../../filters/operators/collection';
import Global from '../../../../store/global-selectors';
import { AdvancedSearchOrderContext } from '../../context';
import MultiSelectDropdown from '../../../components/multi-select-dropdown';
import messages from '../messages';

import style from '../../../style.module.less';

const StoreFilter = () => {
  const allStores = useSelector(Global.selectSellerStores);
  const stores = useMemo(() => {
    return allStores
      .filter((store) => store.isActive)
      .map((store) => ({
        id: store.storeGuid,
        apiKey: store.storeGuid,
        component: store.name,
      }));
  }, [allStores]);
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);
  const { value: values = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedStores = values.map((val) => stores.find((opt) => opt.apiKey === val));

  const onOptionClicked = useCallback(
    (option) => {
      const optionIndex = values.findIndex((opt) => opt === option.apiKey);

      const value = optionIndex >= 0 ? [...values.slice(0, optionIndex), ...values.slice(optionIndex + 1)] : [...values, option.apiKey];

      updateFilter(id, value, isOperator);
    },
    [updateFilter, values],
  );

  const getLabel = () => {
    if (selectedStores.length === 0) {
      return <FormattedMessage {...messages.any} />;
    }

    if (selectedStores.length === 1) {
      return selectedStores[0].component;
    }

    return (
      <FormattedMessage
        {...messages.multiSelection}
        values={{
          count: selectedStores.length,
          total: stores.length,
        }}
      />
    );
  };

  return (
    <span className={style.filterInput}>
      <label className={style.filterLabel}>
        <FormattedMessage {...messages.store} />
      </label>
      <MultiSelectDropdown label={getLabel()} onOptionClicked={onOptionClicked} options={stores} selectedOptions={selectedStores} />
    </span>
  );
};

export default StoreFilter;
